import types from '../../types';

const instantExchangeOrders = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_INSTANT_EXCHANGE_ORDERS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_INSTANT_EXCHANGE_ORDERS_START:
      return { ...state, loading: true };

    case types.GET_INSTANT_EXCHANGE_ORDERS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default instantExchangeOrders;
